import styled from 'styled-components/macro';

const TermsOfUseContainer = styled.div``;

export default function TermsOfUse(): JSX.Element {
  return (
    <TermsOfUseContainer>
      <h2>iWarranty Green Repair Network Terms and Conditions</h2>
      <p>
        These terms of service (“
        <b>Terms and Conditions</b>
        ”) constitute a legally binding agreement between you and
        iWarranty Limited (<b>“iWarranty”</b>) governing your use of
        the iWarranty Platform.&nbsp;
      </p>
      <p>
        iWarranty’s website (including https://iwarranty.io/) (the{' '}
        <b>“Site”</b>
        ), mobile applications (the
        <b>“Apps”</b>
        ), and related services, information and communications are
        collectively referred to as the{' '}
        <b>“iWarranty Platform.”&nbsp;</b>
      </p>
      <p>
        These Terms &amp; Conditions (together with the documents
        referred to in them) govern your use of the iWarranty Platform
        and all related sites, services, applications, and tools,
        which we operate from time to time (the “
        <b>iWarranty Services</b>
        ”).
      </p>
      <p>
        These Terms and Conditions apply to you if you register to use
        the iWarranty Service as a Repairer (a “<b>Repairer</b>
        ”). If you are registering to use the iWarranty Service as a
        Consumer User (a “<b>Consumer User</b>
        ”) please refer to{' '}
        <a href="https://iwarranty.io/terms-and-conditions/">
          iWarranty Consumer Terms and Conditions &amp; Privacy Policy
        </a>
        . By using the iWarranty Service you confirm that you accept
        these Terms &amp; Conditions and that you agree to abide by
        them. If you are accepting these Terms &amp; Conditions on
        behalf of a company or other business entity, you represent
        that you are authorised to do so.
      </p>
      <p />
      <p />
      <h4>
        <b>INFORMATION ABOUT iWARRANTY</b>
      </h4>
      <p>
        The iWarranty Service is operated by iWarranty Ltd (“We or
        “iWarranty”).
      </p>
      <p>
        We are a limited company registered in England and Wales under
        company number 12014798 and have our registered office at
        19-21 Crawford Street, London, W1H 1PJ, UK.&nbsp;
      </p>
      <p>Our VAT Number is: 370988062</p>
      <p>
        Please contact us via:{' '}
        <a href="https://iwarranty.io/contact">
          iwarranty.io/contact
        </a>{' '}
        or{' '}
        <a href="mailto:partnership@iwarranty.co">
          partnership@iwarranty.co
        </a>
      </p>
      <p />
      <p />
      <h4>
        <b>REGISTERING AS A REPAIRER</b>
      </h4>
      <p>
        In order to benefit from all the features of the iWarranty
        Service available to Repairers you will need to register with
        us as a Repairer though our business app. You will be asked to
        provide certain information about your business including your
        business name, contact details and the types of products you
        repair.
      </p>
      <p>
        In addition you will need t o provide proof of address and any
        other documentation or information that we may consider{' '}
        necessary from time to time, such as insurance documentation,{' '}
        as part of the registration process and your ongoing status as
        a Repairer. You must ensure that the information provided by
        you on registration is correct, complete and not misleading.
        You must also inform us promptly of any changes to the
        information that you provide, by updating your details, in
        order that we may communicate with you effectively.
      </p>
      <p>
        By registering as a Repairer you are entering into a contract
        with us. The contract will consist of your registration
        details, the se Terms &amp; Conditions, our{' '}
        <a href="https://iwarranty.io/feedback-policy">
          Privacy Policy
        </a>{' '}
        , our{' '}
        <a href="https://iwarranty.io/code-of-conduct">
          Code of Conduct
        </a>{' '}
        and our{' '}
        <a href="https://iwarranty.io/feedback-policy">
          Feedback Policy
        </a>
        . Unless we have expressly stated otherwise, in the event of
        any conflict or inconsistency between these Terms &amp;
        Conditions and our Privacy Policy or Code of Conduct or
        Feedback Policy, or any other document or legal notice
        published on the iWarranty Service from time to time, these
        Terms &amp; Conditions shall take precedence.
      </p>
      <h4>
        <b>PROVISION OF THE SERVICES TO REPAIRERS</b>
      </h4>
      <p>
        Following registration, we will make certain services
        available to you. The services will include the ability to
        include details of your repair business on our iWarranty
        Platform (“
        <b>Repairer Profile</b>
        ”), the ability to view or receive details of jobs which have
        been submitted by Consumer Users (“
        <b>Jobs</b>
        ”) and the ability to submit quotes in response to Jobs (“
        <b>Quotes</b>
        ”).&nbsp;
      </p>
      <p>
        Please note that your Repairer Profile must not contain any
        contact details for your business other than within the
        specified fields requesting the same, although you will have
        the ability to communicate with Consumer Users using the
        iWarranty Services’ online messaging systems and you may also
        be given the opportunity to contact Consumer Users where you
        have submitted a Quote in response to a Job they have posted.
        You must also ensure that any information you post to or
        transmit via the iWarranty Service, including any content
        contained in Repairer Profile and any Quotes and messages,
        complies with the provisions of our Acceptable Use Policy
        stated below.
      </p>
      <p>
        Full details of the services available to Repairers via the
        iWarranty Service will be published on our website from time
        to time. We are continually seeking to develop and improve the
        services we offer and so we reserve the right, at our absolute
        discretion, to make changes to any part of the iWarranty
        Service without notice.
      </p>
      <h4>
        <b>MEMBERSHIP FEES</b>
      </h4>
      <p>
        In order to have your Repairer Profile published in the
        iWarranty Service and in order to submit Quotes for Jobs,
        Repairers must become a member by paying the applicable annual
        membership fees (the “Membership Fees”). Information about our
        Membership Fees will be posted on the iWarranty Service from
        time to time.
      </p>
      <p>
        Please note that payments made for Membership Fees are
        non-refundable, irrespective of the number of Jobs which are
        notified to you and irrespective of whether or not you have
        submitted Quotes for Jobs or the number of Quotes which are
        submitted.
      </p>
      <p>
        By becoming a member, you agree that your membership will
        continue for a year and renew automatically every year
        thereafter (each a “Membership Year”) and that the annual
        Membership Fee will be automatically charged to you, unless
        you have notified us before the renewal date that you do not
        wish to renew your membership for another Membership Year. You
        will receive an email, fourteen (14) days and seven (7) days
        prior to renewal, informing you that this is about to happen.
        You can cancel your membership for the coming year at any
        point prior to the renewal date by emailing us at
        partnership@iwarranty.co.
      </p>
      <h4>
        <b>SERVICE FEES</b>
      </h4>
      <p>
        By becoming a member and by submitting Quotes or by allowing
        for Quotes to be submitted on your behalf, in respect of Jobs,
        you are also entering into a legally binding contract with us
        under which you agree to pay applicable service fees (the “
        <b>Service Fee</b>
        ”) in the event that a Consumer User initiates a repair
        request via the iW platform and selects you to discuss that
        request (“
        <b>Repair Request</b>
        ”), your Quote is selected by the Consumer User, or you are
        otherwise engaged by the Consumer User to undertake the Job.
        Full details of the applicable Service Fee for a particular
        Job or otherwise using the iWarranty Service will be published
        on the iWarranty Platform from time to time and will be
        provided whenever a Job is notified to you. You agree to
        notify us promptly (and in any event within one (1) working
        day) through the iWarranty Platform if you are selected, or
        engaged, by a Consumer User to undertake any Job with respect
        to a Quote has been submitted, by updating your Job details
        accordingly.
      </p>
      <p>
        In the event that you fail to notify us within one (1) working
        day that you were selected or engaged to undertake a Job and
        we are informed that you were, or if we have reasonable
        grounds for believing that you were, you agree that you will
        be liable to pay the Service Fee to us together with an
        additional administration charge of £9.99 (the “
        <b>Payment Administration Fee</b>
        “).
      </p>
      <p>
        You agree that Service Fees (and, where applicable the Payment
        Administration Fees) are payable if you receive a Repair
        Request, are selected or engaged to undertake a Job,
        irrespective of whether the Job is ultimately completed or is
        cancelled. We shall be under no obligation to refund such fees
        in respect of any Jobs which are not completed or cancelled
        and refunds will only be given in our absolute discretion.
        Under no circumstances will requests for refunds be considered
        where:
      </p>
      <ul>
        <li aria-level={1}>
          they are made later than thirty (30) days after we have
          successfully collected a Service Fee, or invoiced you for a
          Service Fee, or made our first attempt to collect the
          Service Fee from your designated credit or debit card or
          other payment method; or
        </li>
        <li aria-level={1}>
          they are made in respect of Jobs where we hold insufficient
          evidence that follow-up actions have been taken to manage
          the booking with the Consumer User, which must include
          attempts to contact the Consumer User by telephone and
          through the iWarranty Services’ messaging system, after the
          date that the booking was confirmed within the system and
          within a reasonable time of any contact from the Consumer
          User; or
        </li>
        <li aria-level={1}>
          they are made at levels that we consider to be excessive
          based on general usage of the iWarranty Service.
        </li>
      </ul>
      <h4>
        <b>PAYMENT TERMS</b>
      </h4>
      <p>
        Unless otherwise agreed or stated, all fees are quoted in
        Pounds Sterling. You are responsible for paying all fees
        together with any applicable VAT by such methods as we may
        reasonably require from time to time. Unless we have agreed in
        writing to invoice you for any fees due under this agreement
        (or agreed in writing to collect payment by some other method)
        we require that all fees be paid via a credit card or debit
        card or other payment method registered with us and you
        authorise us to collect all such payments immediately on the
        date that they become due. Where we have agreed to invoice you
        for any fees you agree to pay all such invoices within thirty
        (30) days of the date of our invoice.
      </p>
      <p>
        In the event that we are unable to collect any fees from your
        designated credit or debit card or other payment method, or
        (where applicable) you have failed to pay any invoice
        submitted by us by the due date for payment, then (in addition
        to any other rights and remedies which may be available to us)
        you agree that we may charge a late payment administration fee
        of £9.99 (the “Late Payment Administration Fee”) together with
        interest on the overdue amount (from the due date up to the
        date of actual payment) at the rate of 4% per annum above the
        base rate for the time being of the Bank of England. Such
        interest shall accrue on a daily basis and be compounded
        quarterly. In these circumstances, we also reserve the rights
        to suspend your access to or use of the iWarranty Service
        until any outstanding sums are paid in full and/ or to
        terminate our agreement with you in accordance with the
        section&nbsp; entitled <b>Termination </b>
        below.
      </p>
      <h4>
        <b>SUBMISSION OF QUOTES AND QUOTING DATA</b>
      </h4>
      <p>
        By registering to use the iWarranty Service, where we have
        agreed a pricing structure with you in relation to your
        standard repair services, you agree that we may automatically
        submit Quotes on your behalf in response to Jobs which are
        posted in your area. Quotes will be formulated based on
        information provided by the Consumer User including product,
        model and job type (“Job Criteria”) as well as quoting data we
        hold for you (“Quoting Data”). Quotes will either be submitted
        to Consumer Users as standard Quotes or as
        “SmartRepairQuotes”. All “SmartRepairQuotes” will be clearly
        identified as such.
      </p>
      <p>
        Standard Quotes will be generated where you manually submit a
        Quote in direct response to a Repair Request, or, where you
        otherwise agree, we automatically submit on your behalf based
        in information from you where you have either previously
        provided a Quote which matches the Job Criteria, or you have
        otherwise provided us with information about what you would
        quote for the Job Criteria.
      </p>
      <p>
        SmartRepairQuotes may be automatically generated and submitted
        on your behalf where we do not hold Quoting Data for you which
        is an exact match for the Job Criteria. In these cases our
        SmartRepairQuotes software may use the Quoting Data we hold
        for you, as well as benchmarking algorithms we have developed,
        to predict what you are likely to quote for the Job.
      </p>
      <p>
        PLEASE NOTE: If you use the iWarranty Service, you understand,
        acknowledge and agree that any Quotes we submit on your behalf
        will be significantly influenced by the Quoting Data we hold
        for you. In general, the more up to date Quoting Data we hold
        for you the more accurate the Quotes we submit on your behalf
        are likely to be. We therefore strongly encourage Repairers to
        provide as much Quoting Data as possible and to regularly
        review the Quoting Data we hold to ensure that it is accurate
        and up to date.
      </p>
      <p>
        <b>PLEASE ALSO NOTE: </b>
        Whilst we are continually working to improve our SmartQuote
        technology and believe that the SmartRepairQuotes it generates
        should (in most cases) provide a good indication of what a
        particular Repairer is likely to quote for a particular Job,
        within acceptable accuracy tolerances, we do not represent,
        warrant or guarantee to that SmartRepairQuotes will be an
        accurate in all cases. Given the complexity involved in
        quoting for repair work for home appliances or electronics, no
        system can be perfect and errors and inaccuracies will
        inevitably occur. You should take care to carefully review all
        SmartRepairQuotes which have been submitted on your behalf and
        update or amend them (either using the iWarranty Service or in
        discussions with Consumer Users) if you do not consider that
        they are accurate. Under no circumstances will we have any
        liability to you, for any losses or other matters, arising
        from inaccuracy or other error in any SmartQuote.
      </p>
      <p>
        You can submit, review and update the Quotin g Data we hold
        for you by updating your profile section within the iWarranty
        app, searching for the product make and model, selecting a
        service type and then selecting the quote and updating the
        price. A SmartQuote can also be updated at the time of
        receiving a job alert by updating the price and submitting
        this to the Consumer User. After a Job has been accepted you
        cannot update the Quote for that specific Job within the
        iWarranty Service. However, you can discuss any changes
        directly with the Consumer User and edit the price for future
        Quotes of a similar nature.
      </p>
      <p>
        You can choose to submit Quotes for specific types of Jobs by
        amending the categories for which you have Job alerts
        selected.
      </p>
      <p>
        You must ensure that all Quoting Data you provide to us is (at
        the time of submission) accurate and not misleading.
      </p>
      <p>
        We make it clear to all Consumer Users that all Quotes are
        indicative only and only become binding on Repairers once the
        Consumer User has confirmed it directly with you. However, you
        should be aware that if you significantly change or depart
        from Quotes given, without good reason, this may adversely
        impact on a Consumer User’s experience and impact on the
        Feedback and ratings they provide. We therefore encourage you
        to provide us with comprehensive and up to date Quoting Data
        to ensure that your Quotes are as accurate as possible.
      </p>
      <h4>
        <b>OUR RESPONSIBILITIES TO YOU</b>
      </h4>
      <p>
        We will provide iWarranty Service to you using reasonable
        skill and care and in accordance with these Terms &amp;
        Conditions. However, if you use the iWarranty Service as a
        Repairer, you acknowledge and agree that the services we
        provide are subject to the following limitations and
        disclaimers:
      </p>
      <p>
        You acknowledge and agree that we will enable Repairers to
        post Quotes in response to a selection of Jobs based on
        criteria which we (in our absolute discretion) may determine
        from time to time. The criteria may include your geographical
        location as well as the quantity or quality of Quoting Data we
        hold amongst other criteria. In addition you acknowledge that
        the number of Quotes which may be transmitted to a Consumer
        User in relation to any particular Job may be limited to
        Quotes from a specified number of Repairers. Accordingly, we
        do not provide any guarantee that registering as a Repairer
        will result in you being able to submit Quotes, or in Quotes
        being submitted on your behalf, in relation to any Jobs, or in
        relation to any particular volume of Jobs, even if you have
        purchased membership. Nor can we guarantee that your use of
        the iWarranty Service will result in you winning or performing
        any work or any particular volumes of work.
      </p>
      <p>
        You acknowledge and agree that we do not check or verify the
        details of any Jobs which are posted. We have asked all users
        to use the iWarranty Service responsibly and to provide
        accurate information, but cannot guarantee the accuracy,
        integrity or quality of any Jobs or other material which is
        posted by third parties (including Consumer Users).
      </p>
      <p>
        By registering as a Repairer you also understand and agree
        that Consumer Users who have used your services will be able
        to provide Feedback and we may give you a rating based on the
        Feedback you have received. Whilst we have asked all users of
        the Services to act responsibly, we do not actively monitor,
        check or verify Feedback which is posted. Accordingly, you
        acknowledge and agree that we (iWarranty Ltd) shall not have
        any responsibility to you or liability to you for any Feedback
        which is posted by any Consumer User and we will not usually
        become involved or intervene in complaints or disputes
        concerning Feedback, although we reserve the right to do so in
        exceptional circumstances. You may, if you feel that Feedback
        is misleading or libellous, contact us and we will investigate
        but we shall not be obligated to take any action. Please refer
        to our{' '}
        <a href="https://iwarranty.io/feedback-policy">
          Feedback Policy
        </a>{' '}
        for further information concerning our approach to Feedback.
      </p>
      <h4>
        <b>YOUR RESPONSIBILITIES</b>
      </h4>
      <p>
        You agree to abide by these Terms and Conditions when using
        the iWarranty Service and in your dealings with Consumer
        Users.
      </p>
      <p>
        You also agree to abide by the iWarranty{' '}
        <a href="https://iwarranty.io/code-of-conduct">
          Code of Conduct
        </a>{' '}
        at all times when using the iWarranty Service and in your
        dealings with any Consumer Users.
      </p>
      <p>
        You agree that we shall be entitled to permanently or
        temporarily suspend your access to and use of the iWarranty
        Service and/ or terminate our agreement with you, in the event
        that we have reason to believe that you may have failed to
        comply with our Terms &amp; Conditions or Code of Conduct, or
        you are alleged to have done so, or we otherwise believe (in
        our reasonable discretion) that you have acted in a way which
        is or could be detrimental the iWarranty Service or its
        reputation. Under these circumstances we shall not be obliged
        to give you a refund of any Membership Fees or Service Fees
        you have paid.
      </p>
      <p>
        You agree that you will only use any information concerning
        any Consumer User and any Jobs they have posted, which we
        provide to you or which you obtain via the iWarranty Service,
        for the purpose of submitting Quotes and (if you are selected
        to undertake the work) for the purposes of discussing that
        work with the Consumer User and undertaking the Work. You
        agree that you will not use such information for any other
        purpose without first obtaining the Consumer User’s prior
        consent. You also agree to keep any such information secure
        and to comply with all applicable laws concerning privacy and
        data protection in relation to your use of that information.
      </p>
      <p>
        You shall be solely responsible for checking and verifying the
        details of any Job which is transmitted to you via the
        iWarranty Service before you agree to undertake any work for a
        Consumer User and for agreeing with the Consumer User the
        terms on which any work will be performed.
      </p>
      <p>
        You shall be solely responsible for complying with all
        applicable laws and regulations in your dealings with Consumer
        Users and for the performance and quality of any work which
        you agree to undertake for any Consumer User.
      </p>
      <p>
        You agree that your repair work or repaired or replacement
        parts (“
        <b>Repairs</b>
        ”) benefit from a warranty of (90) days from the date of
        repair or replacement and that if within those 90 day period
        you will repair or replace the defective parts without charge
        for labour or parts.
      </p>
      <p>
        You agree that you must only use the iWarranty Service in
        connection with your own business and must not (without our
        prior written consent) use the iWarranty Service for the
        benefit of any other business providing product&nbsp; repair
        and maintenance services.
      </p>
      <p>
        PLEASE NOTE: By registering as a Repairer and by using the
        Services you are agreeing that you shall be solely responsible
        for all products, services and work you may undertake or
        perform for any Consumer User or supply to any Consumer User
        and for your dealings with any Consumer User. You agree to
        indemnify us and hold us harmless from any costs, losses or
        claims which we may suffer or incur and which result from any
        information you submit or transmit via the iWarranty Service
        or from any work which you may agree to perform for any
        Consumer User or from your dealings with any Consumer User or
        your use of their information.
      </p>
      <h4>
        <b>PARTNER PROGRAMMES</b>
      </h4>
      <p>
        From time to time we may work with third parties to make
        certain opportunities to undertake product servicing and
        repair work available to our membership of Repairers and/ or
        to enable our membership of Repairers to access discounted
        products or services or offers or benefits provided by or in
        partnership with third parties (“Partner Programmes”).
      </p>
      <p>
        If you participate in any Partner Programmes, you understand,
        acknowledge and agree that, in addition to continuing to
        comply with these Terms and Conditions and our{' '}
        <a href="https://iwarranty.io/code-of-conduct">
          Code of Conduct
        </a>
        , you must also comply with any applicable Partner Programme
        Terms &amp; Conditions or Service Level Agreements.
      </p>
      <h4>
        <b>PASSWORDS AND SECURITY</b>
      </h4>
      <p>
        If you register to use the iWarranty Service you will be
        required to provide a valid and current email address. You
        will then receive a password (“ID”) in order to activate and
        access your account and use iWarranty Service. You must keep
        your ID confidential and must not disclose it or share it with
        anyone outside your business or organisation. You are
        responsible for preventing unauthorised use of your ID.
      </p>
      <p>
        If you believe there has been a breach of security such as the
        disclosure, theft or unauthorised use of your ID, you must
        notify us immediately. If we reasonably believe that your ID
        is being used in any way which is not permitted by these Terms
        and Conditions, we reserve the right to suspend access rights
        immediately on giving notice to you and to block access from
        your ID until the issue has been resolved.
      </p>
      <h4>
        <b>ACCEPTABLE USE POLICY</b>
      </h4>
      <p>
        The iWarranty Service allows users (including Repairers and
        Consumer Users) to create, edit and submit material for
        inclusion on or transmission via the iWarranty Services,
        including (without limitation) by creating Repairer Profile,
        posting Jobs, submitting Quotes for Jobs, posting Feedback and
        sending messages (“User Content”). Whilst we do not seek to
        monitor or control the submission of User Content, we do
        reserve the right to delete, move and edit any User Content
        submitted where (in our absolute discretion) we consider it
        prudent or necessary to do so.
      </p>
      <p>
        You agree to comply with all applicable laws and regulations
        when using the iWarranty Service. You are solely responsible
        for all User Content you submit for inclusion on or
        transmission via the iWarranty Service. You must ensure that
        all User Content you transmit via the iWarranty Service is
        lawful and honest. In particular you must not post or transmit
        via the iWarranty Service any User Content that:
      </p>
      <ul>
        <li aria-level={1}>
          is fraudulent, dishonest or misleading;
        </li>
        <li aria-level={1}>
          is unlawful, harassing, libellous, abusive, threatening,
          harmful, vulgar, obscene, or otherwise objectionable or
          breaches any laws;
        </li>
        <li aria-level={1}>
          encourages conduct that constitutes a criminal offence,
          gives rise to civil liability or otherwise breaches any
          applicable laws, regulations or code of practice;
        </li>
        <li aria-level={1}>
          infringes the copyright or other rights of any third party;
        </li>
        <li aria-level={1}>
          is technically harmful (including, without limitation,
          computer viruses or other malicious software or harmful
          data).
        </li>
      </ul>
      <p>
        For further information in relation to our approach to
        Feedback, please see our{' '}
        <a href="https://iwarranty.io/feedback-policy">
          Feedback Policy.
        </a>{' '}
        By submitting User Content to us you are granting us a
        royalty-free, non-exclusive licence to use, reproduce, modify,
        translate, make available and distribute the User Content on
        or through the iWarranty Service for the purpose of operating
        the iWarranty Service.
      </p>
      <h4>
        <b>GENERAL DISCLAIMERS</b>
      </h4>
      <p>
        Whilst we endeavour to ensure that the information available
        on or through the iWarranty Service is correct, up to date and
        accurate we do not warrant the accuracy and completeness of
        such material. In particular (but without limitation), the
        iWarranty Service permits you to access and receive
        information supplied by third parties. The third parties
        submitting this information are responsible for ensuring that
        material submitted is accurate and complies with relevant laws
        and codes. We will not be responsible to you for the conduct
        of any such third party or for any error or inaccuracy in any
        material they supply.
      </p>
      <p>
        Although we aim to offer you the best service possible, we
        make no promise that the iWarranty Service will meet your
        requirements. We cannot guarantee that the iWarranty Service
        will be fault or virus free or continuously available. Your
        access to the iWarranty Service may occasionally be restricted
        to allow for repairs, maintenance or the introduction of new
        facilities or services. We may change or discontinue the
        iWarranty Service, or any part thereof by giving reasonable
        notice at any time.
      </p>
      <h4>
        <b>LIABILITY</b>
      </h4>
      <p>
        To the fullest extent permitted by law, we exclude all
        liability to you for any loss of profit, loss of opportunity,
        loss of earnings, loss of anticipated earnings or loss of data
        or for any indirect or consequential losses howsoever arising
        out of your use of iWarranty Service or any fault or problem
        relating to the iWarranty Service or any content received via
        the iWarranty Service.
      </p>
      <p>
        If we are found to have any liability to you under or in
        connection with these Terms &amp; Conditions or in relation to
        the iWarranty Services more generally, whether under contract,
        tort (including negligence) breach of statutory duty or
        otherwise, our total aggregate liability to you shall not, in
        respect of any and all liabilities arising in any Membership
        Year, exceed an amount equal to the total Membership Fee and
        Service Fees paid by you to us in that Membership Year.
      </p>
      <p>
        Nothing in these terms of use shall exclude or limit our
        liability for death or personal injury due to our negligence
        or for fraudulent misrepresentation or for any other liability
        which cannot be excluded or limited under applicable law.
      </p>
      <h4>
        <b>TERMINATION</b>
      </h4>
      <p>
        We may suspend or cancel your registration and/ or terminate
        your access to iWarranty Service and/ or our agreement with
        you, if you are in breach of these Terms &amp; Conditions or
        have made improper use of the iWarranty Service or we have
        reason to believe that you may have breached these Terms and
        Conditions or made improper use of the iWarranty Service.
      </p>
      <p>
        We may also terminate our agreement with you (and your
        membership) for convenience with effect from the end of your
        current Membership Year by giving not less than fourteen (14)
        days prior written notice to you.
      </p>
      <p>
        You may cancel your registration at any time by informing us
        in writing. If you do so you must stop using the iWarranty
        Service. If you terminate your subscription early, you will
        not be entitled to a refund of any Membership Fees and Service
        Fees you have already paid.
      </p>
      <p>
        The suspension, cancellation or termination of your
        registration and your right to use the iWarranty Service shall
        not affect either party’s statutory right or liabilities.
      </p>
      <h4>
        <b>INTELLECTUAL PROPERTY</b>
      </h4>
      <p>
        Unless otherwise stated, the copyright, database right and
        other intellectual property rights in the iWarranty Service
        (including without limitation all content, data, materials and
        technology used or appearing in the iWarranty Service or
        transmitted through it) belongs to us or our licensors. All
        rights are reserved.
      </p>
      <p>
        By using the iWarranty Service you acknowledge and agree that
        we collect aggregated and anonymised data concerning usage of
        the iWarranty Service and the Jobs and Quotes and Quoting Data
        submitted to or via the iWarranty Service. You agree that all
        intellectual property rights and other rights in such
        aggregated and anonymised data shall belong to iWarranty Ltd
        and we may use this data for any purpose whatsoever. However,
        this data will not include any information from which
        particular users of the iWarranty Services (including any
        Consumer Users or Repairer) can be identified.
      </p>
      <h4>
        <b>PRIVACY AND COOKIES</b>
      </h4>
      <p>
        The iWarranty website and iWarranty Service includes areas
        where you are requested to input information about yourself.
        Any information you submit to us shall be subject to the terms
        of our{' '}
        <a href="https://iwarranty.io/terms-and-conditions">
          iWarranty Terms of Use
        </a>{' '}
        &nbsp;and{' '}
        <a href="https://iwarranty.io/privacy-policy">
          Privacy Policy
        </a>
        .
      </p>
      <p>
        We use cookies on our website and as part of the iWarranty
        Service. Further information about cookies and how we use them
        can be found in our{' '}
        <a href="https://iwarranty.io/cookies-policy">
          Cookies Policy
        </a>
        . By registering use you are consenting to our use of cookies
        in the ways described in our{' '}
        <a href="https://iwarranty.io/cookies-policy">
          Cookies Policy
        </a>{' '}
        and{' '}
        <a href="https://iwarranty.io/privacy-policy">
          Privacy Policy
        </a>
        .
      </p>
      <p>&nbsp;</p>
      <p>
        <b>GENERAL</b>
      </p>
      <p>
        All notices shall be given to us via email by using the
        contact details set out above, or to you at either the email
        or postal address you provide during registration. Notice will
        be deemed to be given when an email is received (or else on
        the next business day if it is received on a weekend or a
        public holiday in the place of receipt) or 2 working days
        after the date of posting.
      </p>
      <p>
        If any provision of these Terms &amp; Conditions is held by
        any court of competent authority to be void or unenforceable
        in whole or in part, the other provisions of these Terms &amp;
        Conditions and the remainder of the affected provisions shall
        continue to be valid.
      </p>
      <p>
        The failure to exercise a right or remedy provided by these
        Terms &amp; Conditions or by the law does not constitute a
        waiver of other rights or remedies.
      </p>
      <p>
        We may revise these Terms &amp; Conditions at any time. You
        are expected to check these Terms &amp; Conditions from time
        to time to take notice of any changes we make as they are
        legally binding on you. Some of the provisions contained in
        these Terms &amp; Conditions may also be superseded by
        provisions or notices published elsewhere on our website or
        the iWarranty Service from time to time.
      </p>
      <p>
        These Terms &amp; Conditions will be subject to the laws of
        England and Wales and the English courts shall have
        jurisdiction to resolve any disputes between us.
      </p>
      <p>These Terms and Conditions updated on 01 October 2021.</p>
      <p>&nbsp;</p>
    </TermsOfUseContainer>
  );
}
